export default __webpack_public_path__ + "static/media/edit-pen-icon.a1b3a177.svg";